import './scss/index.scss';

import { dcFactory } from 'dc';
import FormWidgetComponent from './js/form-widget.component';

dcFactory.register(FormWidgetComponent);
